module.exports = __webpack_public_path__ + "img/doctor.fc881bff.png";